var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mt-tabbar',{attrs:{"fixed":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}},_vm._l((_vm.atabs),function(tab){return _c('mt-tab-item',{attrs:{"id":tab.id}},[_c('img',{attrs:{"slot":"icon","src":tab.icon},slot:"icon"}),_vm._v("\n    "+_vm._s(tab.name)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a41532","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/tabbar.vue
// module id = null
// module chunks = 